import { createContext } from 'react';
import type { MouseContextValue } from '../types';

/**
 * React context for mouse functionality
 * Provides access to mouse instance and control methods
 */
export const MouseContext: React.Context<MouseContextValue | null> = createContext<MouseContextValue | null>(null);
